import {
  SET_SETTINGS,
  SET_MAX_KEYS,
  SET_PRODUCT,
  SET_PLUGIN_INFO,
} from './settings.constants';


const initialState = {
  maxKeys: 50,
  product: {},
  pluginInfo: {},
};

const userReducer = (state = initialState, action) => {
  const { type, payload = {} } = action;

  switch (type) {
    case SET_SETTINGS: {
      return {
        ...state,
        ...payload,
      };
    }

    case SET_MAX_KEYS: {
      return {
        ...state,
        maxKeys: payload,
      };
    }

    case SET_PRODUCT: {
      return {
        state,
        product: payload,
      }
    }

    case SET_PLUGIN_INFO: {
      return {
        state,
        pluginInfo: payload,
      }
    }

    default:
      return state;
  }
};

export default userReducer;
